(function () {
  var MAX_PAGES = 40;
  var observer = null;

  function getRoot() {
    return document.getElementById('CollectionProductGrid');
  }

  function getGrid() {
    return document.getElementById('template--collection');
  }

  function getProductId(li) {
    if (li.getAttribute('data-product-id')) return li.getAttribute('data-product-id');
    var json = li.querySelector('.product-grid-json');
    return json && json.id ? json.id : null;
  }

  function reveal(root) {
    if (!root) return;
    root.classList.remove('collection-grid--awaiting-sold-out-sort');
    root.dataset.soldOutFullSort = 'done';
  }

  function sortLocal(grid) {
    var children = Array.prototype.slice.call(grid.children);
    var soldOut = children.filter(function (el) {
      return el.getAttribute('data-product-available') === 'false';
    });
    if (!soldOut.length) return;

    var seenSoldOut = false;
    var needsSort = false;
    for (var i = 0; i < children.length; i++) {
      var available = children[i].getAttribute('data-product-available');
      if (available === 'false') {
        seenSoldOut = true;
      } else if (available === 'true' && seenSoldOut) {
        needsSort = true;
        break;
      }
    }
    if (!needsSort) return;

    soldOut.forEach(function (el) {
      grid.appendChild(el);
    });
  }

  function buildPageUrl(page) {
    var url = new URL(window.location.href);
    if (page <= 1) url.searchParams.delete('page');
    else url.searchParams.set('page', String(page));
    return url.href;
  }

  function detectTotalPages(root) {
    var meta = root.querySelector('#collection-sold-out-meta');
    var fromMeta = meta ? parseInt(meta.getAttribute('data-collection-pages') || '0', 10) : 0;
    if (fromMeta > 0) {
      root.dataset.collectionPages = String(fromMeta);
      return fromMeta;
    }

    var fromData = parseInt(root.dataset.collectionPages || '0', 10);
    if (fromData > 0) return fromData;

    var pageLinks = root.querySelectorAll('.collection-pagination .pagination .page-item a.page-link[href*="page="]');
    var max = 1;
    Array.prototype.forEach.call(pageLinks, function (link) {
      try {
        var page = parseInt(new URL(link.href, window.location.origin).searchParams.get('page') || '1', 10);
        if (page > max) max = page;
      } catch (e) {}
    });

    if (root.querySelector('#AjaxinateInfiniteScrolling a[href], #AjaxinateLoadMore a[href]')) {
      return Math.max(max, 2);
    }
    return max;
  }

  function collectProductsFrom(grid, productMap) {
    if (!grid) return;
    Array.prototype.forEach.call(grid.querySelectorAll(':scope > li[data-product-available]'), function (li) {
      var id = getProductId(li);
      if (!id || productMap.has(id)) return;
      productMap.set(id, li);
    });
  }

  function collectExtras(grid) {
    if (!grid) return [];
    return Array.prototype.slice.call(grid.querySelectorAll(':scope > li:not([data-product-available])'));
  }

  function hidePagination(root) {
    var pagination = root.querySelector('.collection-pagination');
    if (pagination) pagination.style.display = 'none';
  }

  function rebuildGrid(grid, productMap, extras) {
    var available = [];
    var soldOut = [];

    productMap.forEach(function (li) {
      if (li.getAttribute('data-product-available') === 'false') {
        soldOut.push(li);
      } else {
        available.push(li);
      }
    });

    while (grid.firstChild) {
      grid.removeChild(grid.firstChild);
    }

    available.forEach(function (li) {
      grid.appendChild(li);
    });
    extras.forEach(function (li) {
      grid.appendChild(li);
    });
    soldOut.forEach(function (li) {
      grid.appendChild(li);
    });
  }

  function fetchPage(url) {
    return fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Failed to load collection page');
        return response.text();
      })
      .then(function (html) {
        return new DOMParser().parseFromString(html, 'text/html');
      });
  }

  function loadFullCollectionSorted() {
    var root = getRoot();
    var grid = getGrid();
    if (!root || !grid) return;
    if (root.dataset.soldOutFullSort === 'loading' || root.dataset.soldOutFullSort === 'done') {
      sortLocal(grid);
      return;
    }

    var totalPages = detectTotalPages(root);
    var currentPage = parseInt(new URL(window.location.href).searchParams.get('page') || '1', 10);

    if (totalPages <= 1) {
      sortLocal(grid);
      reveal(root);
      return;
    }

    root.dataset.soldOutFullSort = 'loading';
    root.classList.add('collection-grid--awaiting-sold-out-sort');
    if (observer) observer.disconnect();

    var productMap = new Map();
    var extras = [];
    var pagesToFetch = [];
    var pageLimit = Math.min(totalPages, MAX_PAGES);

    for (var page = 1; page <= pageLimit; page++) {
      if (page === currentPage) {
        collectProductsFrom(grid, productMap);
        if (page === 1) extras = collectExtras(grid);
        continue;
      }
      pagesToFetch.push(page);
    }

    if (currentPage !== 1) {
      extras = [];
    }

    var fetches = pagesToFetch.map(function (page) {
      return fetchPage(buildPageUrl(page)).then(function (doc) {
        var pageGrid = doc.getElementById('template--collection');
        collectProductsFrom(pageGrid, productMap);
        if (page === 1 && !extras.length) {
          extras = collectExtras(pageGrid).map(function (li) {
            return document.importNode(li, true);
          });
        }
      });
    });

    Promise.all(fetches)
      .then(function () {
        if (!productMap.size) {
          sortLocal(grid);
          reveal(root);
          bindObserver(grid);
          return;
        }

        var adopted = new Map();
        productMap.forEach(function (li, id) {
          adopted.set(id, li.ownerDocument === document ? li : document.importNode(li, true));
        });

        var adoptedExtras = extras.map(function (li) {
          return li.ownerDocument === document ? li : document.importNode(li, true);
        });

        rebuildGrid(grid, adopted, adoptedExtras);
        hidePagination(root);
        reveal(root);
        document.dispatchEvent(new CustomEvent('collection:sold-out-sorted'));
        bindObserver(grid);
      })
      .catch(function () {
        sortLocal(grid);
        root.dataset.soldOutFullSort = 'error';
        root.classList.remove('collection-grid--awaiting-sold-out-sort');
        bindObserver(grid);
      });
  }

  function bindObserver(grid) {
    if (!grid) return;
    if (observer) observer.disconnect();
    observer = new MutationObserver(function () {
      sortLocal(grid);
    });
    observer.observe(grid, { childList: true });
  }

  function bindCollectionSoldOutSort() {
    var root = getRoot();
    var grid = getGrid();
    if (!root || !grid) return;

    delete root.dataset.soldOutFullSort;

    var totalPages = detectTotalPages(root);
    if (totalPages > 1) {
      root.classList.add('collection-grid--awaiting-sold-out-sort');
      root.dataset.collectionPages = String(totalPages);
    }

    bindObserver(grid);
    sortLocal(grid);
    loadFullCollectionSorted();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindCollectionSoldOutSort);
  } else {
    bindCollectionSoldOutSort();
  }

  document.addEventListener('paginate', bindCollectionSoldOutSort);
})();
